import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './index.module.less';
import cs from 'classnames';
import { changeProvincesCities, areaList, easyProvinceChange } from '../../config-v2';
import { Col, Row } from 'antd';
import { useMethods } from '@lhb/hook';
import { deepCopy } from '@lhb/func';

export interface V2ProvincePanelProps {
  /**
   * @description 选中省份的key，默认是id，可选code
   * @default id
   */
  activeKey?: string;
  /**
   * @description 选中省份的值
   */
  activeValue: string | number;
  /**
   * @description 选中省份的值的set方法
   */
  setActiveValue: Function;
  /**
   * @description 选中值变化后的回调，会返回详细信息
   */
  onChange?: (itemInfo: any) => void;
  /**
   * @description 额外添加的外层类
   */
  className?: string;
  /**
   * @description 是否允许选择港澳台
   * @default false
   */
  allowSpecialRegion?: boolean;
}

/**
* @description 便捷文档地址
* @see https://reactpc.lanhanba.net/components/form/v2province-panel
*/
const V2ProvincePanel: React.FC<V2ProvincePanelProps> = ({
  activeKey = 'id',
  activeValue,
  setActiveValue,
  onChange,
  className,
  allowSpecialRegion = false
}) => {
  const dispatch = useDispatch();
  const province = useSelector((state: any) => state.common.provincesCities);
  const methods = useMethods({
    clickHandle(activeKey, disabled) {
      !disabled && setActiveValue(activeKey);
    }
  });
  useEffect(() => {
    const getAreaList = async () => {
      const cityResult: any = await areaList({ type: 2 });
      dispatch(changeProvincesCities(cityResult));
    };
    // 如果不存在则进行请求
    if (!province.length) {
      getAreaList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (province && onChange) {
      onChange(province.find(item => {
        return item[activeKey] === activeValue;
      }));
    }
  }, [activeValue, province]);
  const newProvince = useMemo(() => {
    if (allowSpecialRegion && province) {
      return deepCopy(province).map(item => {
        if (['台湾', '香港', '澳门'].some(region => item.name.indexOf(region) !== -1)) {
          item.disabled = false;
        }
        return item;
      });
    }
    return province;
  }, [province]);
  return (
    <Row className={cs(styles.v2ProvincePanel, className)} gutter={[8, 8]}>
      {
        newProvince?.map((item: any, index: number) => {
          return (
            <Col span={4} key={index}>
              <div
                className={cs([
                  styles.v2ProvincePanelItem,
                  item[activeKey] === activeValue && styles.active,
                  item.disabled && styles.disabled,
                  'v2ProvincePanelItem'
                ])}
                onClick={() => methods.clickHandle(item[activeKey], item.disabled)}
              >
                {easyProvinceChange[item.name] || item.name}
              </div>
            </Col>
          );
        })
      }
    </Row>
  );
};

export default V2ProvincePanel;
